export const getTodaysScheduleHours = (schedule: {
  curbside: {
    closing: string | null | undefined;
    opening: string | null | undefined;
  };
  delivery: {
    closing: string | null | undefined;
    opening: string | null | undefined;
  };
  pickup: {
    closing: string | null | undefined;
    opening: string | null | undefined;
  };
}) => {
  const { pickup, delivery, curbside } = schedule;
  const pickupHours =
    pickup?.opening?.length && pickup?.closing?.length
      ? `${pickup.opening} - ${pickup.closing}`
      : null;
  const deliveryHours =
    delivery?.opening?.length && delivery?.closing?.length
      ? `${delivery.opening} - ${delivery.closing}`
      : null;
  const curbsideHours =
    curbside?.opening?.length && curbside?.closing?.length
      ? `${curbside.opening} - ${curbside.closing}`
      : null;

  return {
    pickupHours,
    deliveryHours,
    curbsideHours,
  };
};
